import { axios } from "utils";

import { PUBLIC_BEEF_URL as endpoint } from "consts";

import { BeefCowType, BeefFeedAdditive, BeefFeedType, BeefManureStorageType } from "models";

export const getBeefCowTypes = async ({ enabled }: { enabled?: boolean } = {}): Promise<BeefCowType[]> =>
  axios.get(`${endpoint}/beef-cow-types`, { params: { enabled } });

export const getBeefFeedAdditives = async (): Promise<BeefFeedAdditive[]> => axios.get(`${endpoint}/beef-feed-additives`);

export const getBeefFeedTypes = async ({ enabled }: { enabled?: boolean } = {}): Promise<BeefFeedType[]> =>
  axios.get(`${endpoint}/beef-feed-types`, { params: { enabled } });

export const getBeefManureStorageTypes = async (): Promise<BeefManureStorageType[]> => axios.get(`${endpoint}/beef-manure-storage-types`);
